export const deleteCartProduct = (productId: number) => ({
  type: "@saga/DELETE_CART_PRODUCT",
  payload: productId,
});
